import { render, staticRenderFns } from "./ActionNotification.vue?vue&type=template&id=55155ebf&scoped=true&"
import script from "./ActionNotification.vue?vue&type=script&lang=js&"
export * from "./ActionNotification.vue?vue&type=script&lang=js&"
import style0 from "./ActionNotification.vue?vue&type=style&index=0&id=55155ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55155ebf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VRow,VSwitch,VTooltip})
